import store from '../store';
import { auth } from '../firebase';
import { getCookieByName } from '../utils';

const ifNotAuthenticated = (to, from, next) => {
  if (!auth.currentUser) {
    next();
    return;
  }
  next('/panel/owner');
};

const ifAuthenticated = async (to, from, next) => {
  if (auth.currentUser && getCookieByName('uid')) {
    await store.dispatch('_init');
    await store.dispatch('fetchContactGroups');
    store.commit('SAVE_USER', JSON.parse(getCookieByName('user')));
    next();
    return;
  }
  await store.dispatch('signOut');
  next('/login');
};

const isOwner = async (to, from, next) => {
  if (store.getters.isOwner && auth.currentUser) {
    next();
    return;
  }
  next('/loader');
};

export {
  ifNotAuthenticated,
  ifAuthenticated,
  isOwner,
};



// WEBPACK FOOTER //
// ./src/router/guard.js